import get from 'lodash.get';
import omit from 'lodash.omit';
import isEmpty from 'lodash.isempty';
import {
    getPmPeriodByCurrentPeriod,
    LICENSE,
    PERIOD,
} from '../../../constants/shared/CommonConstants';
import { getGrowthAnalysisPeriodBySelectedPeriod } from '../../../constants/shared/GrowthAnalysisConstants';
import { GRADE } from '../../../constants/shared/GradesConstants';

const removeEmptySummerPeriod = enrollmentData => {
    const updatedChosenSchoolWindowDates = { ...enrollmentData.chosenSchoolWindowDates };
    if (
        updatedChosenSchoolWindowDates.SUMMER === null ||
        (updatedChosenSchoolWindowDates.SUMMER &&
            updatedChosenSchoolWindowDates.SUMMER.startDate === null &&
            updatedChosenSchoolWindowDates.SUMMER.endDate === null)
    ) {
        delete updatedChosenSchoolWindowDates.SUMMER;
    }

    return updatedChosenSchoolWindowDates;
};

const applySummerRuleValidation = (enrollmentData, period) => {
    const updatedChosenSchoolWindowDates = removeEmptySummerPeriod(enrollmentData);
    const licensingInfo = get(enrollmentData, 'licensingConfiguration.licensingInfo', []);
    let { currentPeriod } = enrollmentData;
    let selectedPeriod = period || currentPeriod;

    if (licensingInfo.includes(LICENSE.LOUISIANA)) {
        const gradesInSelectedClass = get(enrollmentData, 'studentsByGrade', [])
            .filter(item => !isEmpty(item.students))
            .map(item => item.grade);

        if (
            updatedChosenSchoolWindowDates.SUMMER &&
            !gradesInSelectedClass.includes(GRADE.THIRD_GRADE)
        ) {
            delete updatedChosenSchoolWindowDates.SUMMER;
        }

        if (currentPeriod === PERIOD.SUMMER && !gradesInSelectedClass.includes(GRADE.THIRD_GRADE)) {
            selectedPeriod = PERIOD.EOY;
            currentPeriod = PERIOD.EOY;
        }
    }
    return {
        selectedPeriod,
        currentPeriod,
        updatedChosenSchoolWindowDates,
    };
};

const processEnrollmentData = props => {
    const { data, districtId, schoolId, classId, period } = props;
    const enrollmentData = get(data, 'enrollmentData', {});
    const accountInfo = get(data, 'accountInfo', {});
    const licensingInfo = get(enrollmentData, 'licensingConfiguration.licensingInfo', []);

    const { selectedPeriod, currentPeriod, updatedChosenSchoolWindowDates } =
        applySummerRuleValidation(enrollmentData, period);
    return {
        ...omit(data, ['enrollmentData', 'accountInfo']),
        accountName: get(accountInfo, 'accountName', ''),
        ...omit(enrollmentData, ['licensingConfiguration', 'fourthWindowLabel']),
        chosenDistrictUid: districtId || enrollmentData.chosenDistrictUid,
        chosenSchoolUid: schoolId || enrollmentData.chosenSchoolUid,
        chosenClasseUid: classId || enrollmentData.chosenClasseUid,
        selectedPeriod,
        currentPeriod,
        selectedPmPeriod: getPmPeriodByCurrentPeriod(currentPeriod),
        selectedGrowthAnalysisPeriod: getGrowthAnalysisPeriodBySelectedPeriod(currentPeriod),
        licensingInfo,
        gradeAvailabilityInfo: get(
            enrollmentData,
            'licensingConfiguration.gradeAvailabilityInfo',
            [],
        ),
        chosenSchoolWindowDates: updatedChosenSchoolWindowDates,
        summerPeriodLabel: enrollmentData.fourthWindowLabel,
    };
};

export const processAdditionalEnrollmentData = response => {
    const { licensingInfo = [], gradeAvailabilityInfo = [] } = get(
        response,
        'data.getEnrollmentResolvers_v2.enrollmentData.licensingConfiguration',
    );

    return {
        licensingInfo,
        gradeAvailabilityInfo,
    };
};

export default processEnrollmentData;
